<template>
  <div>
      <div class="reportpage">
          <div class="reportbox" v-if="showresult">
              <div class="title">恭喜您刚刚完成了一节课</div>
              <div class="middle">
                  <div id="teacherresult"></div>
              </div>
              <div class="bottom">
                  <div class="comment_top">老师评语</div>
                  <div class="comment_text">{{resultData.comment}}</div>
              </div>
          </div>
          <div class="reporterror"  v-if="!showresult">{{text}}</div>
      </div>
  </div>
</template>

<script>
import { common } from "../../../common.js";
export default {
    data: function(){
        return {
            showresult: false,
            text: 'loading...',
            resultData: {},
        }
    },
    mounted: function(){
        document.getElementById('app').className+=' appmobile';
        const id = this.$route.query.id;
        let self = this;
        common.requestFun(self, "get", "/student/course/grade/"+id, {}, (res) => {
            if(res.data.code == 200){
            self.showresult = true;
            self.$nextTick(()=>{
                const data = res.data.data||{};
            self.resultData = data;
            var value = [data['attendance']||0,data['pronunciation']||0,data['comprehension']||0,data['fluency']||0,data['creativity']||0]
                var dom = document.getElementById("teacherresult");
                var myChart = self.$echarts.init(dom);
                var option = {
                radar: [
                    {
                        indicator: [
                            { name: '参与度',max: 10 },
                            { name: '发音',max: 10 },
                            { name: '理解力',max: 10 },
                            { name: '流畅度',max: 10 },
                            { name: '创造力',max: 10 }
                        ],
                        center: ['50%','56%'],
                        radius: 75,
                        startAngle: 90,
                        splitNumber: 4,
                        name: {
                            textStyle: {
                                color: '#282828',
                                fontWeight: 500,
                                fontFamily: 'PingFang',
                                lineHeight: 20,
                                fontSize: 18
                            }
                        },
                        splitArea: {
                            areaStyle: {
                                color: ['rgba(149, 208, 250, 1)',
                                    'rgba(149, 208, 250, 0.8)', 
                                    'rgba(149, 208, 250, 0.6)',
                                    'rgba(149, 208, 250, 0.4)'],
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(209, 236, 255, 0.4)'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: 'rgba(209, 236, 255, 0.4)'
                            }
                        }
                    }
                ],
                series: [{
                    type: 'radar',
                    data: [
                    {
                        value: value,
                        lineStyle: {
                        color: 'rgb(214,160,155)'
                        },
                        symbol: 'none'
                    }
                    ]
                }]
                }
                myChart.setOption(option, true);
            })
            
            }else{
                self.showresult = false;
                self.text = res.data.msg;
            }
        });
        
    }
}
import "../../assets/css/common.css"
</script>

<style scoped src="./index.css"></style>